export const CookiesSection2 = () => {
  return (
    <>
      <section id="facebook-cookies">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          3. Facebook and Social Media Cookies
        </h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-4">
              IMPORTANT: Our Service integrates with Facebook, Instagram, and WhatsApp, which may
              place their own cookies on your device.
            </p>
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            3.1 Facebook Platform Cookies
          </h3>
          <p>When you connect your Facebook, Instagram, or WhatsApp accounts to our Service:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>
              Facebook may set cookies to authenticate your connection and maintain your session
            </li>
            <li>
              These cookies enable features like accessing your Facebook Pages, Instagram Business
              Accounts, and WhatsApp Business Accounts
            </li>
            <li>
              Facebook uses these cookies for security, fraud prevention, and service delivery
            </li>
          </ul>
          <p>
            For more information about Facebook&apos;s use of cookies, please see:{' '}
            <a
              href="https://www.facebook.com/privacy/policies/cookies"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Facebook Cookies Policy
            </a>
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            3.2 Facebook Pixel (If Used)
          </h3>
          <p>If we use Facebook Pixel on our website, it places cookies on your device to:</p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Track conversions and measure the effectiveness of advertising campaigns</li>
            <li>Build custom audiences for targeted advertising</li>
            <li>Retarget visitors who have previously interacted with our Service</li>
          </ul>
          <p>
            Facebook Pixel cookies may track your browsing activity across different websites and
            services. You can opt out of Facebook advertising tracking through your{' '}
            <a
              href="https://www.facebook.com/ads/preferences"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Facebook Ad Preferences
            </a>
            .
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            3.3 Social Media Plugins and Widgets
          </h3>
          <p>
            Our Service may include social media features such as Facebook, Instagram, or Twitter
            share buttons. These features may:
          </p>
          <ul className="ml-6 space-y-2 list-disc">
            <li>Set cookies to track your interactions with social media content</li>
            <li>Collect your IP address and which page you&apos;re visiting</li>
            <li>Function properly only if you&apos;re logged into the respective social network</li>
          </ul>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            3.4 Cross-Site Tracking Disclosure
          </h3>
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
            <p className="font-semibold text-gray-900 mb-2">CROSS-SITE TRACKING NOTICE:</p>
            <p className="text-gray-700">
              Facebook and other third-party services integrated with our platform may track your
              activity across different websites and online services. This cross-site tracking is
              used for advertising, analytics, and personalization purposes.
            </p>
            <p className="text-gray-700 mt-3">To limit cross-site tracking, you can:</p>
            <ul className="ml-6 mt-2 space-y-1 list-disc text-gray-700">
              <li>Adjust your browser&apos;s privacy settings</li>
              <li>Use browser extensions that block tracking</li>
              <li>Opt out of personalized advertising</li>
              <li>Configure your social media privacy settings</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="third-party-cookies">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Third-Party Cookies</h2>
        <div className="space-y-4 text-base leading-relaxed text-gray-700">
          <p>
            In addition to our own cookies, we use third-party services that may place cookies on
            your device. These include:
          </p>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Third-Party Services:</h3>
            <ul className="space-y-3">
              <li>
                <strong className="text-gray-900">Google Analytics:</strong>
                <p className="text-sm text-gray-700">
                  Analytics and performance tracking. Learn more:{' '}
                  <a
                    href="https://policies.google.com/technologies/cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Google Cookies Policy
                  </a>
                </p>
              </li>
              <li>
                <strong className="text-gray-900">Meta (Facebook, Instagram, WhatsApp):</strong>
                <p className="text-sm text-gray-700">
                  Platform integration, authentication, and analytics. Learn more:{' '}
                  <a
                    href="https://www.facebook.com/privacy/policies/cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Facebook Cookies Policy
                  </a>
                </p>
              </li>
            </ul>
          </div>

          <p>
            We do not control third-party cookies. These cookies are governed by the privacy
            policies of the respective third parties. We encourage you to review their policies to
            understand how they use cookies and how you can control them.
          </p>
        </div>
      </section>
    </>
  );
};
